export default {
    closed: "Aula ao vivo fechada",
    do_you_confirm_your_registration_for_the_live_class: "Confirma a sua inscrição para a aula ao vivo {title}?",
    do_you_confirm_your_unsubscription_to_the_live_class: "Confirma cancelar a inscrição para a aula ao vivo {title}?",
    live_class_closed: "Aula ao vivo fechada",
    live_class_offline: "Aula ao vivo offline",
    live_class_opened: "Aula ao vivo aberta",
    live: "Ao vivo",
    loading_live_classes: "Carregando aulas ao vivo",
    next: "Próximas",
    no_live_classes_are_available_at_the_moment: "Não há aulas ao vivo disponíveis no momento",
    no_live_classes_are_available_with_the_selected_filter: "Não há aulas ao vivo disponíveis para o filtro selecionado",
    no_vacancy: "Vagas esgotadas",
    opened: "Aula ao vivo aberta",
    please_wait_the_class_will_start_automatically: "Por favor, aguarde. Você entrará na sala em alguns instantes.",
    receive_emails_about_this_live_class: "Receber emails sobre essa aula ao vivo",
    register_for_the_live_class: "Inscrever-se na aula ao vivo",
    subscribe: "Inscrever",
    subscribed: "Inscrito",
    successfully_signed_up_for_the_live_class: "Inscrição feita para a aula ao vivo com sucesso",
    this_class_has_ended: "Esta aula terminou",
    transmission_date: "Data de Transmissão",
    transmission_finished: "Transmissão Finalizada",
    unsubscribe_from_the_live_class: "Cancelar inscrição da aula ao vivo",
    unsubscribe_successfully_for_the_live_class: "Inscrição cancelada com sucesso",
    unsubscribe: "Cancelar inscrição",
    your_live_class_will_start_soon_please_wait: "Sua aula ao vivo irá começar em breve, por favor aguarde",
    this_reaction_assessment_will_only_be_unlocked_after_completing_all_activities_in_this_module: "Esta avaliação de reação só será liberada após a conclusão de todas as atividades deste módulo.",
    this_activity_will_only_be_unlocked_after_the_live_class_instructors_authorization: "Esta atividade só será liberada após a autorização do responsável pela aula ao vivo."
}